<div>
  <app-page-breadcrumb pageTitle="Badges" />
  <div class="space-y-5 sm:space-y-6">
    <div>
      <app-component-card title="With Light Background">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <!-- Light Variant -->
          <div><app-badge variant="light" color="primary"> Primary </app-badge></div>
          <div><app-badge variant="light" color="success"> Success </app-badge></div>
          <div><app-badge variant="light" color="error"> Error </app-badge></div>
          <div><app-badge variant="light" color="warning"> Warning </app-badge></div>
          <div><app-badge variant="light" color="info"> Info </app-badge></div>
          <div><app-badge variant="light" color="light"> Light </app-badge></div>
          <div><app-badge variant="light" color="dark"> Dark </app-badge></div>
        </div>
      </app-component-card>
    </div>

    <div>
      <app-component-card title="With Solid Background">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <!-- Light Variant -->
          <div><app-badge variant="solid" color="primary"> Primary </app-badge></div>
          <div><app-badge variant="solid" color="success"> Success </app-badge></div>
          <div><app-badge variant="solid" color="error"> Error </app-badge></div>
          <div><app-badge variant="solid" color="warning"> Warning </app-badge></div>
          <div><app-badge variant="solid" color="info"> Info </app-badge></div>
          <div><app-badge variant="solid" color="light"> Light </app-badge></div>
          <div><app-badge variant="solid" color="dark"> Dark </app-badge></div>
        </div>
      </app-component-card>
    </div>

    <div>
      <app-component-card title="Light Background with Left Icon">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <div><app-badge variant="light" color="primary" [startIcon]="plusIcon">Primary</app-badge></div>
          <div><app-badge variant="light" color="success" [startIcon]="plusIcon">Success</app-badge></div>
          <div><app-badge variant="light" color="error" [startIcon]="plusIcon">Error</app-badge></div>
          <div><app-badge variant="light" color="warning" [startIcon]="plusIcon">Warning</app-badge></div>
          <div><app-badge variant="light" color="info" [startIcon]="plusIcon">Info</app-badge></div>
          <div><app-badge variant="light" color="light" [startIcon]="plusIcon">Light</app-badge></div>
          <div><app-badge variant="light" color="dark" [startIcon]="plusIcon">Dark</app-badge></div>
        </div>
      </app-component-card>
    </div>

    <div>
      <app-component-card title="Solid Background with Left Icon">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <div><app-badge variant="solid" color="primary" [startIcon]="plusIcon">Primary</app-badge></div>
          <div><app-badge variant="solid" color="success" [startIcon]="plusIcon">Success</app-badge></div>
          <div><app-badge variant="solid" color="error" [startIcon]="plusIcon">Error</app-badge></div>
          <div><app-badge variant="solid" color="warning" [startIcon]="plusIcon">Warning</app-badge></div>
          <div><app-badge variant="solid" color="info" [startIcon]="plusIcon">Info</app-badge></div>
          <div><app-badge variant="solid" color="light" [startIcon]="plusIcon">Light</app-badge></div>
          <div><app-badge variant="solid" color="dark" [startIcon]="plusIcon">Dark</app-badge></div>
        </div>
      </app-component-card>
    </div>

    <div>
      <app-component-card title="Light Background with Right Icon">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <div><app-badge variant="light" color="primary" [endIcon]="plusIcon">Primary</app-badge></div>
          <div><app-badge variant="light" color="success" [endIcon]="plusIcon">Success</app-badge></div>
          <div><app-badge variant="light" color="error" [endIcon]="plusIcon">Error</app-badge></div>
          <div><app-badge variant="light" color="warning" [endIcon]="plusIcon">Warning</app-badge></div>
          <div><app-badge variant="light" color="info" [endIcon]="plusIcon">Info</app-badge></div>
          <div><app-badge variant="light" color="light" [endIcon]="plusIcon">Light</app-badge></div>
          <div><app-badge variant="light" color="dark" [endIcon]="plusIcon">Dark</app-badge></div>
        </div>
      </app-component-card>
    </div>

    <div>
      <app-component-card title="Solid Background with Right Icon">
        <div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
          <div><app-badge variant="solid" color="primary" [endIcon]="plusIcon">Primary</app-badge></div>
          <div><app-badge variant="solid" color="success" [endIcon]="plusIcon">Success</app-badge></div>
          <div><app-badge variant="solid" color="error" [endIcon]="plusIcon">Error</app-badge></div>
          <div><app-badge variant="solid" color="warning" [endIcon]="plusIcon">Warning</app-badge></div>
          <div><app-badge variant="solid" color="info" [endIcon]="plusIcon">Info</app-badge></div>
          <div><app-badge variant="solid" color="light" [endIcon]="plusIcon">Light</app-badge></div>
          <div><app-badge variant="solid" color="dark" [endIcon]="plusIcon">Dark</app-badge></div>
        </div>
      </app-component-card>
    </div>
  </div>
</div>